import script from "./SettingsTile.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsTile.vue?vue&type=script&setup=true&lang=js"

import "./SettingsTile.vue?vue&type=style&index=0&id=2caba3ba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2caba3ba"]])

export default __exports__